import React, { useReducer } from 'react'
import analytics from '../config/analytics'

import Leaderboard from '../asset/bannerreflow/png/Leaderboard.png'
import Portrait from '../asset/bannerreflow/png/Portrait.png'
import HalfPage from '../asset/bannerreflow/png/HalfPage.png'
import Original from '../asset/bannerreflow/png/Original.png'
import MediumRectangle from '../asset/bannerreflow/png/MediumRectangle.png'
import Square from '../asset/bannerreflow/png/Square.png'
import Landscape from '../asset/bannerreflow/png/Landscape.png'

import { getRef, getDebugMode } from '../lib/easybake'

export const EasybakeContext = React.createContext()
export const EasybakeConsumer = EasybakeContext.Consumer

const gCache = {}
const adSizes = [
    {
        id: '300250',
        label: '300x250',
        checked: true,
        width: 300,
        height: 250,
        name: 'Original',
        image: Original,
        orientation: 'landscape'
    },
    {
        id: '336280',
        label: '336x280',
        checked: false,
        width: 336,
        height: 280,
        name: 'Medium Rectangle',
        image: MediumRectangle,
        orientation: 'landscape'
    },
    {
        id: '12060',
        label: '120x60',
        checked: false,
        width: 120,
        height: 60,
        name: 'Landscape',
        image: Landscape,
        orientation: 'landscape'
    },
    {
        id: '72890',
        label: '728x90',
        checked: false,
        width: 728,
        height: 90,
        name: 'Leaderboard',
        image: Leaderboard,
        orientation: 'landscape'
    },
    {
        id: '240400',
        label: '240x400',
        checked: false,
        width: 240,
        height: 400,
        name: 'Portrait',
        image: Portrait,
        orientation: 'portrait'
    },
    {
        id: '300600',
        label: '300x600',
        checked: false,
        width: 300,
        height: 600,
        name: 'Half Page',
        image: HalfPage,
        orientation: 'portrait'
    },
    {
        id: '320320',
        label: '320x320',
        checked: false,
        width: 320,
        height: 320,
        name: 'Square',
        image: Square,
        orientation: 'square'
    }
]

const formCompanySize = [
    {
        label: 'Self-employed',
        value: 'Self-employed',
        selected: false
    },
    {
        label: '1-10 employees',
        value: '1-10 employees',
        selected: false
    },
    {
        label: '11-50 employees',
        value: '11-50 employees',
        selected: false
    },
    {
        label: '51-200 employees',
        value: '51-200 employees',
        selected: false
    },
    {
        label: '201-500 employees',
        value: '201-500 employees',
        selected: false
    },
    {
        label: '501-1,000 employees',
        value: '501-1,000 employees',
        selected: false
    },
    {
        label: '1,001-5,000 employees',
        value: '1,001-5,000 employees',
        selected: false
    },
    {
        label: '5,001-10,000 employees',
        value: '5,001-10,000 employees',
        selected: false
    },
    {
        label: '10,001+ employees',
        value: '10,001+ employees',
        selected: false
    }
]

const initialState = {
    dMode: getDebugMode(),
    page: getRef(document.location.href),
    action: null,
    group: null,
    wait: false,
    spinnerTimeout: 1500,
    cache: gCache,
    adSizes: adSizes,
    cred: null,
    formCompanySize: formCompanySize,
    formFullName: null,
    formEmail: null,
    formCompany: null,
    formRole: null,
    formUseCase: null,
    formAgreement: false,
    formDevTermsAgreement: false,
    formConfigNotified: false,
    formEnterpriseFullName: null,
    formEnterpriseEmail: null,
    formEnterpriseCompany: null,
    formEnterprisePhone: null,
    formEnterpriseUseCase: null,
    formEnterpriseEstimatedVolume: null,
    formEnterpriseAgreement: false,
    userOrgs: [],
    userOrgsInts: [],
    customFiles: [],
    upload: false,
    isApiReady: false,
    isApiDone: false,
    uploadProgress: 0,
    customAfterImage: null,
    aperitif: null,
    utStorage: null,
    act: null,
    awsCustomerId: null,
    awsCustomerClientId: null,
    awsProdCode: null,
    projectName: null
}

const reducer = (state, anAction) => {
    switch (anAction.type) {
    case 'reset':
        return initialState
    case 'reset-actions':
        return { ...initialState, page: state.page }
    case 'wait':
        return { ...state, wait: anAction.payload }
    case 'page':
        return { ...state, page: anAction.payload }
    case 'action':
        return { ...state, action: anAction.payload }
    case 'group':
        return { ...state, group: anAction.payload }
    case 'set-action': {
        const { group, action, on, upload } = anAction.payload
        if (on) {
            analytics.sendEventName('apply', `${group}:${action}`)
            switch (action) {
                case "psactionscustom":
                    return { ...state, 
                        group, 
                        action, 
                        upload: true, 
                        customFiles: [], 
                        isApiReady: false, 
                        isApiDone: false, 
                        customAfterImage: null,
                        wait: false,
                        aperitif: null,
                        utStorage: null
                    }
                default:
                    return { ...state, group, action, wait: on, customFiles: [], isApiReady: false, isApiDone: false }
            }
        } else {
            return { ...initialState, cache: gCache, page: state.page, ut: state.ut }
        }
    }
    case 'set-customAfterImage': {
        const { customAfterImage } = anAction.payload
        return { ...state, customAfterImage: customAfterImage }
    }
    case 'set-uploadProgress': {
        const { uploadProgress } = anAction.payload
        return { ...state, uploadProgress: uploadProgress }
    }
    case 'set-dMode': {
        const { dMode } = anAction.payload
        return { ...state, dMode: dMode }
    }
    case 'set-page': {
        const { page } = anAction.payload
        // console.log(`PAGE: ${page}`)
        analytics.sendPageName(page)
        const initAdSizes = adSizes.map(adSize => {
            if (adSize.name !== 'Original') {
                adSize.checked = false
            }
            return adSize
        })
        if (page === 'create' || page === 'form' || page === 'signup' || page === 'awsmp' || page === 'contactsales' || page === 'enterprisesetupmeeting') {
            return { ...state, page, cred: null, formEmail: state.formEmail }
        }
        return { ...initialState, page, wait: false, adSizes: initAdSizes, ut: state.ut, cred: state.cred, userOrgs: state.userOrgs }
    }
    case 'upload':
        return { ...state, upload: anAction.payload }
    case 'set-cache': {
        const { key, value } = anAction.payload
        gCache[key] = value
        return { ...state }
    }
    case 'set-sizes': {
        const { group, action, e, adSizes } = anAction.payload
        if (adSizes.filter(size => size.checked === true).length !== 1) {
            analytics.sendEventName('apply', `${group}:${action}`)
            return { ...state, group, action, e, wait: true, adSizes: adSizes }
        } else {
            return { ...state, group, action, adSizes: adSizes }
        }
    }
    case 'set-ut': {
        const { ut } = anAction.payload
        return { ...state, ut: ut }
    }
    case 'set-act': {
        const { act } = anAction.payload
        return { ...state, act: act }
    }
    case 'set-awsCustomerId': {
        const { awsCustomerId } = anAction.payload
        return { ...state, awsCustomerId: awsCustomerId }
    }
    case 'set-awsCustomerClientId': {
        const { awsCustomerClientId } = anAction.payload
        return { ...state, awsCustomerClientId: awsCustomerClientId }
    }
    case 'set-awsProdCode': {
        const { awsProdCode } = anAction.payload
        return { ...state, awsProdCode: awsProdCode }
    }
    case 'set-projectName': {
        const { projectName } = anAction.payload
        return { ...state, projectName: projectName }
    }
    case 'set-cred': {
        const { cred } = anAction.payload
        return { ...state, cred: cred }
    }
    case 'set-formFullName': {
        const { formFullName } = anAction.payload
        return { ...state, formFullName: formFullName }
    }
    case 'set-formEmail': {
        const { formEmail } = anAction.payload
        return { ...state, formEmail: formEmail }
    }
    case 'set-formCompany': {
        const { formCompany } = anAction.payload
        return { ...state, formCompany: formCompany }
    }
    case 'set-formRole': {
        const { formRole } = anAction.payload
        return { ...state, formRole: formRole }
    }
    case 'set-formUseCase': {
        const { formUseCase } = anAction.payload
        return { ...state, formUseCase: formUseCase }
    }
    case 'set-formAgreement': {
        const { formAgreement } = anAction.payload
        return { ...state, formAgreement: formAgreement }
    }
    case 'set-formDevTermsAgreement': {
        const { formDevTermsAgreement } = anAction.payload
        return { ...state, formDevTermsAgreement: formDevTermsAgreement }
    }
    case 'set-formConfigNotified': {
        const { formConfigNotified } = anAction.payload
        return { ...state, formConfigNotified: formConfigNotified }
    }
    case 'set-formCompanySize': {
        const { formCompanySize } = anAction.payload
        return { ...state, formCompanySize: formCompanySize }
    }
    case 'set-formEnterpriseFullName': {
        const { formEnterpriseFullName } = anAction.payload
        return { ...state, formEnterpriseFullName: formEnterpriseFullName }
    }
    case 'set-formEnterpriseEmail': {
        const { formEnterpriseEmail } = anAction.payload
        return { ...state, formEnterpriseEmail: formEnterpriseEmail }
    }
    case 'set-formEnterpriseCompany': {
        const { formEnterpriseCompany } = anAction.payload
        return { ...state, formEnterpriseCompany: formEnterpriseCompany }
    }
    case 'set-formEnterprisePhone': {
        const { formEnterprisePhone } = anAction.payload
        return { ...state, formEnterprisePhone: formEnterprisePhone }
    }
    case 'set-formEnterpriseUseCase': {
        const { formEnterpriseUseCase } = anAction.payload
        return { ...state, formEnterpriseUseCase: formEnterpriseUseCase }
    }
    case 'set-formEnterpriseEstimatedVolume': {
        const { formEnterpriseEstimatedVolume } = anAction.payload
        return { ...state, formEnterpriseEstimatedVolume: formEnterpriseEstimatedVolume }
    }
    case 'set-formEnterpriseAgreement': {
        const { formEnterpriseAgreement } = anAction.payload
        return { ...state, formEnterpriseAgreement: formEnterpriseAgreement }
    }
    case 'set-userOrgs': {
        const { userOrgs } = anAction.payload
        return { ...state, userOrgs: userOrgs }
    }
    case 'set-userOrgsInts': {
        const { userOrgsInts } = anAction.payload
        return { ...state, userOrgsInts: userOrgsInts }
    }
    case 'set-customFiles': {
        const { customFiles } = anAction.payload
        return { ...state, customFiles: customFiles }
    }
    case 'set-isApiReady': {
        const { isApiReady } = anAction.payload
        return { ...state, isApiReady, wait: true }
    }
    case 'set-isApiDone': {
        const { isApiDone } = anAction.payload
        return { ...state, isApiDone }
    }
    case 'set-aperitif': {
        const { aperitif } = anAction.payload
        return { ...state, aperitif: aperitif }
    }
    case 'set-utStorage': {
        const { utStorage } = anAction.payload
        return { ...state, utStorage: utStorage }
    }
    default:
        throw new Error()
    }
}

export default function EasybakeProvider ({ children }) {
    const [state, dispatch] = useReducer(reducer, initialState)
    const value = { ...state, dispatch }
    return (
    // value prop is where we define what values
    // that are accessible to consumer components
        <EasybakeContext.Provider value={value}>
            {children}
        </EasybakeContext.Provider>
    )
}
